import { render, staticRenderFns } from "./vedioDetail.vue?vue&type=template&id=a8b1d724&scoped=true"
import script from "./vedioDetail.vue?vue&type=script&lang=js"
export * from "./vedioDetail.vue?vue&type=script&lang=js"
import style0 from "./vedioDetail.vue?vue&type=style&index=0&id=a8b1d724&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b1d724",
  null
  
)

export default component.exports